<div class="f-photo-replace">
  <div
    (change)="onSelect($event)"
    [accept]="'.jpeg, .jpg, .png'"
    [multiple]="true"
    class="custom-dropzone"
    ngx-dropzone
  >
    <ngx-dropzone-label>
      <div>
        <span class="custom-dropzone__label">{{
          "reports.PHOTO.PRESS_OR_DROP" | translate
        }}</span>
      </div>
    </ngx-dropzone-label>
    <ngx-dropzone-image-preview
      (removed)="onRemove(i)"
      *ngFor="let i of images"
      [file]="i"
      [removable]="true"
      ngProjectAs="ngx-dropzone-preview"
    >
      <ngx-dropzone-label>{{ i.name }} ({{ i.type }})</ngx-dropzone-label>
    </ngx-dropzone-image-preview>
  </div>

  <div class="tr-button">
    <button
      (click)="replacePhoto()"
      class="save-btn"
    >
      <app-icon
        *ngIf="design === 'modern'"
        [color]="'white'"
        [iconName]="['Character', 'save']"
      ></app-icon>
      <fa-icon *ngIf="design !== 'modern'" [icon]="['fas', 'save']" class="icon"></fa-icon>
      <span>{{ "reports.PHOTO.SAVE" | translate }}</span>
    </button>
  </div>
</div>
